/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { FloorParentFragmentDoc } from "../../floors/graphql/fragments.generated"
import { ProductPositionRecursiveParentFragmentDoc } from "../../product-positions/graphql/fragments.recursive.generated"
import { RoomRecursiveParentFragmentDoc } from "../../rooms/graphql/fragments.recursive.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type AttachmentEntitiesQueryVariables = Exact<{
  id: string
}>

export type AttachmentEntitiesQuery = {
  __typename: "Query"
  attachmentEntities: {
    __typename: "AttachmentEntities"
    id: string
    count: number
    entities: Array<
      | {
          __typename: "Floor"
          id: string
          label?: string | null
          parent?: { __typename: "Project"; id: string; title: string } | null
        }
      | {
          __typename: "ProductPosition"
          id: string
          variantKey: string
          displayPosition?: string | null
          parent?:
            | { __typename: "Project"; id: string; title: string }
            | {
                __typename: "Room"
                id: string
                label?: string | null
                number: string
                parent?:
                  | {
                      __typename: "Floor"
                      id: string
                      label?: string | null
                      parent?: {
                        __typename: "Project"
                        id: string
                        title: string
                      } | null
                    }
                  | { __typename: "Project"; id: string; title: string }
                  | null
              }
            | null
        }
      | { __typename: "Project"; id: string; title: string }
      | {
          __typename: "Room"
          id: string
          label?: string | null
          number: string
          parent?:
            | {
                __typename: "Floor"
                id: string
                label?: string | null
                parent?: {
                  __typename: "Project"
                  id: string
                  title: string
                } | null
              }
            | { __typename: "Project"; id: string; title: string }
            | null
        }
    >
  }
}

export const AttachmentEntitiesDocument = gql`
  query AttachmentEntities($id: ID!) {
    attachmentEntities(id: $id)
      @rest(
        type: "AttachmentEntities"
        endpoint: "attachmentEntities"
        path: "/project-list/attachments/{args.id}/entities"
      ) {
      id
      count
      entities {
        ... on Project {
          id
          title
        }
        ... on Floor {
          id
          label
          ...FloorParent
        }
        ... on Room {
          id
          label
          number
          ...RoomRecursiveParent
        }
        ... on ProductPosition {
          id
          variantKey
          displayPosition
          ...ProductPositionRecursiveParent
        }
      }
    }
  }
  ${FloorParentFragmentDoc}
  ${RoomRecursiveParentFragmentDoc}
  ${ProductPositionRecursiveParentFragmentDoc}
`

/**
 * __useAttachmentEntitiesQuery__
 *
 * To run a query within a React component, call `useAttachmentEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentEntitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAttachmentEntitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AttachmentEntitiesQuery,
    AttachmentEntitiesQueryVariables
  > &
    (
      | { variables: AttachmentEntitiesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AttachmentEntitiesQuery,
    AttachmentEntitiesQueryVariables
  >(AttachmentEntitiesDocument, options)
}
export function useAttachmentEntitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AttachmentEntitiesQuery,
    AttachmentEntitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AttachmentEntitiesQuery,
    AttachmentEntitiesQueryVariables
  >(AttachmentEntitiesDocument, options)
}
// @ts-ignore
export function useAttachmentEntitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttachmentEntitiesQuery,
    AttachmentEntitiesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AttachmentEntitiesQuery,
  AttachmentEntitiesQueryVariables
>
export function useAttachmentEntitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentEntitiesQuery,
        AttachmentEntitiesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AttachmentEntitiesQuery | undefined,
  AttachmentEntitiesQueryVariables
>
export function useAttachmentEntitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentEntitiesQuery,
        AttachmentEntitiesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AttachmentEntitiesQuery,
    AttachmentEntitiesQueryVariables
  >(AttachmentEntitiesDocument, options)
}
export type AttachmentEntitiesQueryHookResult = ReturnType<
  typeof useAttachmentEntitiesQuery
>
export type AttachmentEntitiesLazyQueryHookResult = ReturnType<
  typeof useAttachmentEntitiesLazyQuery
>
export type AttachmentEntitiesSuspenseQueryHookResult = ReturnType<
  typeof useAttachmentEntitiesSuspenseQuery
>
export type AttachmentEntitiesQueryResult = Apollo.QueryResult<
  AttachmentEntitiesQuery,
  AttachmentEntitiesQueryVariables
>
